import React from 'react';
import cn from './style.module.scss';
export default function ArtContainer({ children }: any) {
  return <div className={cn.artContainer}> {children}</div>;
}
